interface ImagePreviewProps {
  images: string[]
  onRemove: (index: number) => void
}

/**
 * Component for displaying preview of pasted images.
 * Shows thumbnails with remove buttons for each image.
 */
export function ImagePreview({ images, onRemove }: ImagePreviewProps) {
  if (images.length === 0) return null

  return (
    <div className='mb-3 rounded-lg bg-blue-50 p-3 dark:bg-blue-900/20'>
      <div className='mb-2 flex items-center justify-between'>
        <span className='text-xs font-medium text-blue-700 dark:text-blue-400'>
          Images to send ({images.length})
        </span>
      </div>
      <div className='flex flex-wrap gap-2'>
        {images.map((image, index) => (
          <div key={index} className='relative'>
            <img
              src={image}
              alt={`Pasted ${(index + 1).toString()}`}
              className='h-16 w-16 rounded-md border border-blue-200 object-cover dark:border-blue-700'
            />
            <button
              type="button"
              onClick={() => onRemove(index)}
              className='absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-white hover:bg-red-600'
            >
              <i className='fa-solid fa-xmark text-[10px]' />
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}